import { FC } from 'react';
import { PublicityCardProps } from './types';
import { Flex, Text, Title, Button } from '@mantine/core';
import Link from 'next/link';
import { NEWS_HEADER_IMAGE } from 'src/mockdata';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { InView } from 'react-intersection-observer';
import { useViewPublicity } from '@hooks/mutations/useViewPublicity';

export const PublicityCard: FC<PublicityCardProps> = ({ publicity }) => {
  const { t } = useTranslation('common');

  const { mutate: viewPublicity } = useViewPublicity();

  if (!publicity) {
    return null;
  }

  const url = `/api/publicity/${publicity.id}/count`;

  const handleInView = () => {
    viewPublicity(publicity.id);
  };

  if (publicity.type === 'BANNER') {
    return (
      <InView
        as="div"
        style={{
          padding: 0,
          margin: 0,
          width: '100%',
          aspectRatio: '5 / 1',
        }}
        onChange={(inView) => {
          if (inView) {
            handleInView();
          }
        }}
        triggerOnce={true}
        threshold={0.8}
      >
        <Link
          href={url}
          target="_blank"
          style={{ width: '100%', display: 'flex', height: '100%' }}
        >
          <Flex h="100%" pos="relative" w="100%">
            <Image
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 1200px"
              priority
              src={publicity?.image?.key ?? NEWS_HEADER_IMAGE}
              alt={publicity.title}
              style={{ objectFit: 'cover' }}
            />
          </Flex>
        </Link>
      </InView>
    );
  }

  if (publicity.type === 'NEWS') {
    return (
      <InView
        as="div"
        style={{ padding: 0, margin: 0 }}
        onChange={(inView) => {
          if (inView) {
            handleInView();
          }
        }}
        triggerOnce={true}
        threshold={0.8}
      >
        <Flex direction="column" maw={400}>
          <Title variant="h3Orange">{publicity.title}</Title>
          <Text variant="body" mt={12} component="p">
            {publicity.description}
          </Text>
          <Link target="_blank" style={{ marginTop: 16 }} href={url}>
            <Button variant="tertiary">{t('common.knowMore')}</Button>
          </Link>
        </Flex>
      </InView>
    );
  }

  return (
    <InView
      as="div"
      style={{ padding: 0, margin: 0, width: '100%' }}
      onChange={(inView) => {
        if (inView) {
          handleInView();
        }
      }}
      triggerOnce={true}
      threshold={0.8}
    >
      <Link
        target="_blank"
        href={url}
        style={{ display: 'block', width: '100%' }}
      >
        <Flex
          w="100%"
          pos="relative"
          style={{ aspectRatio: '3 / 4', overflow: 'hidden' }}
        >
          <Image
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 25vw"
            style={{
              objectFit: 'cover',
            }}
            src={publicity?.image?.key ?? NEWS_HEADER_IMAGE}
            alt={publicity.title}
          />
        </Flex>
      </Link>
    </InView>
  );
};
